import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import GrantPhoto from '../images/grant2.jpg';
import '../styles/template.css';

const ElevatePage = () => {
  
  const handlePurchase = () => {
    window.location.href = 'https://7de6-grant.systeme.io/98063388';
  };

  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Elevate</h1>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/elevate">Elevate</Link></li>
            <li><Link to="/connect">Connect</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <h2 className="main-heading">Elevate Your Potential</h2>
        
        <section className="partners-intro">
          <p style={{ 
            fontSize: 'clamp(16px, 4vw, 20px)', 
            lineHeight: '1.6', 
            maxWidth: '900px', 
            margin: '0 auto',
            padding: '0 15px'
          }}>
            Transform your thinking patterns and unlock the mindset that separates achievers from dreamers. 
  
            "Develop a Winning Mindset" gives you strategies for success in a competitive world
          </p>
        </section>

        <section className="partners-grid">
          {/* About the Instructor */}
          <div className="partner-category">
            <h3 style={{ 
              fontSize: 'clamp(20px, 5vw, 24px)', 
              marginBottom: '30px', 
              textAlign: 'center',
              padding: '0 15px'
            }}>Meet Your Instructor</h3>
            <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto', padding: '0 15px' }}>
              <div style={{ marginBottom: '30px' }}>
                <img 
                  src={GrantPhoto} 
                  alt="Grant Reynolds" 
                  style={{
                    width: '100%',
                    maxWidth: '350px',
                    height: 'auto',
                    borderRadius: '20px',
                    border: '5px solid #2c5aa0',
                    boxShadow: '0 10px 30px rgba(44, 90, 160, 0.3)',
                    display: 'block',
                    margin: '0 auto'
                  }}
                />
              </div>
              <div>
                <h4 style={{ 
                  fontSize: 'clamp(24px, 6vw, 32px)', 
                  marginBottom: '20px', 
                  color: '#2c5aa0'
                }}>Grant Reynolds</h4>
                <p style={{ 
                  fontSize: 'clamp(18px, 4.5vw, 22px)', 
                  color: '#495057', 
                  marginBottom: '25px', 
                  fontWeight: '600'
                }}>
                  <strong>Air Force Veteran | Martial Artist | CEO/Founder Know Yourself LLC</strong>
                </p>
                <p style={{ 
                  fontSize: 'clamp(16px, 4vw, 19px)', 
                  lineHeight: '1.8', 
                  marginBottom: '20px', 
                  textAlign: 'left', 
                  maxWidth: '700px', 
                  margin: '0 auto'
                }}>
                  Grant brings a unique perspective to mindset development, combining military discipline, 
                  martial arts philosophy, and real-world business experience. As a technology professional 
                  and entrepreneur, he understands the mental challenges of building something from nothing 
                  and the mindset shifts required to achieve lasting success.
                </p>
              </div>
            </div>
          </div>

          {/* Featured Course */}
          <div className="partner-category">
            <h3 style={{ 
              fontSize: 'clamp(20px, 5vw, 24px)', 
              marginBottom: '20px',
              padding: '0 15px'
            }}>The Course</h3>
            <div className="partner-cards">
              <div className="partner-card featured-partner" style={{
                display: 'flex',
                flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
                alignItems: window.innerWidth <= 768 ? 'center' : 'flex-start',
                padding: '20px',
                margin: '15px'
              }}>
                <div className="partner-logo" style={{ 
                  marginRight: window.innerWidth <= 768 ? '0' : '30px',
                  marginBottom: window.innerWidth <= 768 ? '20px' : '0'
                }}>
                  <div style={{
                    width: 'clamp(100px, 20vw, 140px)',
                    height: 'clamp(100px, 20vw, 140px)',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'clamp(40px, 8vw, 60px)',
                    color: 'white',
                    fontWeight: 'bold',
                    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)'
                  }}>
                    🧠
                  </div>
                </div>
                <div className="partner-info" style={{ textAlign: window.innerWidth <= 768 ? 'center' : 'left' }}>
                  <h4 style={{ 
                    fontSize: 'clamp(20px, 5vw, 26px)', 
                    marginBottom: '15px', 
                    color: '#667eea' 
                  }}>Develop a Winning Mindset</h4>
                  <p style={{ 
                    fontSize: 'clamp(14px, 3.5vw, 18px)', 
                    lineHeight: '1.7', 
                    marginBottom: '20px' 
                  }}>
                    Master the mental strategies that drive success in business and life. This comprehensive video course 
                    teaches you how to overcome limiting beliefs, build unshakeable confidence, and develop the resilience 
                    needed to achieve your most ambitious goals.
                  </p>
                  
                  {/* Course Features */}
                  <div className="partner-credentials" style={{ marginTop: '20px' }}>
                    <strong style={{ 
                      fontSize: 'clamp(14px, 3.5vw, 18px)', 
                      color: '#667eea' 
                    }}>What You'll Get:</strong>
                    <ul style={{ 
                      marginTop: '15px', 
                      paddingLeft: '25px', 
                      fontSize: 'clamp(14px, 3.2vw, 17px)', 
                      lineHeight: '1.8' 
                    }}>
                      <li>High-quality video modules</li>
                      <li>Mobile & desktop streaming</li>
                      <li>Access to exclusive community (coming soon)</li>
                    </ul>
                  </div>
                  
                  <div style={{ 
                    marginTop: '25px', 
                    display: 'flex', 
                    flexDirection: window.innerWidth <= 480 ? 'column' : 'row',
                    gap: '20px', 
                    alignItems: 'center',
                    justifyContent: window.innerWidth <= 768 ? 'center' : 'flex-start'
                  }}>
                    <div className="price-tag" style={{
                      background: '#28a745',
                      color: 'white',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: 'bold',
                      fontSize: 'clamp(18px, 4vw, 22px)',
                      boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
                    }}>
                      $79
                    </div>
                    <button 
                      onClick={handlePurchase}
                      style={{
                        background: '#007bff',
                        color: 'white',
                        border: 'none',
                        padding: '18px 35px',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        fontSize: 'clamp(14px, 3.5vw, 18px)',
                        boxShadow: '0 4px 15px rgba(0, 123, 255, 0.3)',
                        transition: 'transform 0.2s',
                        width: window.innerWidth <= 480 ? '100%' : 'auto',
                        minWidth: '200px'
                      }}
                      onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                      onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                      🚀 Get Instant Access
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* What You'll Learn */}
          <div className="partner-category">
            <h3 style={{ 
              fontSize: 'clamp(20px, 5vw, 24px)', 
              marginBottom: '20px',
              padding: '0 15px'
            }}>What You'll Learn</h3>
            <div className="partner-cards" style={{
              display: 'grid',
              gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px',
              padding: '0 15px'
            }}>
              <div className="partner-card" style={{ padding: '25px', margin: '0' }}>
                <div className="partner-info">
                  <h4 style={{ 
                    fontSize: 'clamp(16px, 4vw, 20px)', 
                    marginBottom: '15px', 
                    color: '#2c5aa0' 
                  }}>🎯 Mental Discipline & Focus</h4>
                  <p style={{ 
                    fontSize: 'clamp(14px, 3.2vw, 17px)', 
                    lineHeight: '1.6' 
                  }}>Learn techniques for developing laser-sharp focus and mental discipline that cuts through distraction and doubt.</p>
                </div>
              </div>
              <div className="partner-card" style={{ padding: '25px', margin: '0' }}>
                <div className="partner-info">
                  <h4 style={{ 
                    fontSize: 'clamp(16px, 4vw, 20px)', 
                    marginBottom: '15px', 
                    color: '#2c5aa0' 
                  }}>🥋 Resilience & Adaptability</h4>
                  <p style={{ 
                    fontSize: 'clamp(14px, 3.2vw, 17px)', 
                    lineHeight: '1.6' 
                  }}>Master mental toughness, turning setbacks into comebacks, and maintaining composure under pressure.</p>
                </div>
              </div>
              <div className="partner-card" style={{ padding: '25px', margin: '0' }}>
                <div className="partner-info">
                  <h4 style={{ 
                    fontSize: 'clamp(16px, 4vw, 20px)', 
                    marginBottom: '15px', 
                    color: '#2c5aa0' 
                  }}>💼 Entrepreneurial Mindset</h4>
                  <p style={{ 
                    fontSize: 'clamp(14px, 3.2vw, 17px)', 
                    lineHeight: '1.6' 
                  }}>Develop the thinking patterns and decision-making frameworks used by successful business leaders and entrepreneurs.</p>
                </div>
              </div>
              <div className="partner-card" style={{ padding: '25px', margin: '0' }}>
                <div className="partner-info">
                  <h4 style={{ 
                    fontSize: 'clamp(16px, 4vw, 20px)', 
                    marginBottom: '15px', 
                    color: '#2c5aa0' 
                  }}>🧠 Psychology of Success</h4>
                  <p style={{ 
                    fontSize: 'clamp(14px, 3.2vw, 17px)', 
                    lineHeight: '1.6' 
                  }}>Understand the science behind peak performance and how to rewire your brain for sustained achievement and growth.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Coming Soon: Elevate Society */}
        <section className="elevate-society-preview" style={{ 
          padding: '50px 20px', 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          margin: '40px 15px',
          borderRadius: '20px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3 style={{ 
            fontSize: 'clamp(24px, 6vw, 32px)', 
            marginBottom: '25px', 
            fontWeight: 'bold' 
          }}>🚀 Coming Soon: Elevate Society</h3>
          <p style={{ 
            fontSize: 'clamp(16px, 4vw, 22px)', 
            lineHeight: '1.6', 
            maxWidth: '900px', 
            margin: '0 auto 30px' 
          }}>
            Join an exclusive community of entrepreneurs, creators, and professionals committed to self-actualization and peak performance. 
            Get access to expert-led courses, live mentorship, and a supportive Discord community that accelerates your growth.
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))', 
            gap: '25px', 
            maxWidth: '1000px', 
            margin: '30px auto',
            textAlign: 'left'
          }}>
            <div style={{ 
              background: 'rgba(255,255,255,0.1)', 
              padding: '25px', 
              borderRadius: '15px',
              backdropFilter: 'blur(10px)'
            }}>
              <h4 style={{ 
                fontSize: 'clamp(16px, 4vw, 20px)', 
                marginBottom: '15px' 
              }}>🎓 Expert-Led Courses</h4>
              <p style={{ 
                fontSize: 'clamp(14px, 3.2vw, 16px)', 
                lineHeight: '1.5' 
              }}>Access premium courses from industry professionals, with templates and structured learning paths designed for real-world application.</p>
            </div>
            
            <div style={{ 
              background: 'rgba(255,255,255,0.1)', 
              padding: '25px', 
              borderRadius: '15px',
              backdropFilter: 'blur(10px)'
            }}>
              <h4 style={{ 
                fontSize: 'clamp(16px, 4vw, 20px)', 
                marginBottom: '15px' 
              }}>💬 Exclusive Community</h4>
              <p style={{ 
                fontSize: 'clamp(14px, 3.2vw, 16px)', 
                lineHeight: '1.5' 
              }}>Connect with like-minded individuals in our private Discord, featuring topic-based discussions, live Q&As, and peer mentorship.</p>
            </div>
            
            <div style={{ 
              background: 'rgba(255,255,255,0.1)', 
              padding: '25px', 
              borderRadius: '15px',
              backdropFilter: 'blur(10px)'
            }}>
              <h4 style={{ 
                fontSize: 'clamp(16px, 4vw, 20px)', 
                marginBottom: '15px' 
              }}>🎯 Personal Guidance</h4>
              <p style={{ 
                fontSize: 'clamp(14px, 3.2vw, 16px)', 
                lineHeight: '1.5' 
              }}>Work with dedicated counselors who help you choose the right courses and create a personalized growth path based on your goals.</p>
            </div>
          </div>
          
          <p style={{ 
            fontSize: 'clamp(14px, 3.5vw, 18px)', 
            marginTop: '25px', 
            opacity: '0.9' 
          }}>
            Be the first to know when Elevate Society launches - 
            <strong style={{ textDecoration: 'underline' }}> premium community access starting soon!</strong>
          </p>
        </section>

        {/* Final CTA */}
        <section className="partnership-cta" style={{ padding: '40px 20px' }}>
          <h3 style={{ 
            fontSize: 'clamp(20px, 5vw, 28px)', 
            marginBottom: '20px',
            textAlign: 'center' 
          }}>Ready to Transform Your Mindset?</h3>
          <p style={{ 
            fontSize: 'clamp(16px, 4vw, 20px)', 
            lineHeight: '1.6', 
            maxWidth: '800px', 
            margin: '0 auto 30px',
            textAlign: 'center',
            padding: '0 15px'
          }}>
            Start your journey with our flagship course, and get early access to Elevate Society when it launches. 
            Combine military discipline, martial arts philosophy, and entrepreneurial strategy 
            to develop the unshakeable mindset that drives lasting success.
          </p>

          <div style={{ 
            display: 'flex', 
            gap: '20px', 
            justifyContent: 'center', 
            marginTop: '30px', 
            flexWrap: 'wrap',
            padding: '0 15px'
          }}>
            <button 
              onClick={handlePurchase}
              style={{
                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                color: 'white',
                border: 'none',
                padding: '25px 50px',
                borderRadius: '12px',
                fontSize: 'clamp(16px, 4vw, 22px)',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 8px 25px rgba(40, 167, 69, 0.4)',
                transition: 'all 0.3s ease',
                width: window.innerWidth <= 480 ? '100%' : 'auto',
                maxWidth: '400px'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 12px 35px rgba(40, 167, 69, 0.5)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.4)';
              }}
            >
              🚀 Get Instant Access - $79
            </button>
          </div>

          <div style={{ 
            marginTop: '30px', 
            fontSize: 'clamp(14px, 3.5vw, 18px)', 
            color: '#6c757d', 
            textAlign: 'center',
            padding: '0 15px'
          }}>
            <p style={{
              display: window.innerWidth <= 480 ? 'block' : 'inline',
              lineHeight: '1.8'
            }}>
              {window.innerWidth <= 480 ? (
                <>
                  ✅ Instant access after purchase<br />
                  ✅ Lifetime access<br />
                  ✅ Mobile & desktop compatible
                </>
              ) : (
                "✅ Instant access after purchase | ✅ Lifetime access | ✅ Mobile & desktop compatible"
              )}
            </p>
          </div>
        </section>
      </main>

      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ElevatePage;
